import React, { useState } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { RiAddLargeFill } from "react-icons/ri";

import Modal from './Modal';




function EmailProvider() {
    const [showfilter, setshowfilter] = useState(false)
    const [EnableSSLandTLS, setEnableSSLandTLS] = useState(false)
    const [ProviderType, setProviderType] = useState('')
    const [SMTPUsernmae, setSMTPUsernmae] = useState('')
    const [SenderEmail, setSenderEmail] = useState('')

    const initialUsers = [];
    const [users, setUsers] = useState(initialUsers);


    const [currentPage, setcurrentPage] = useState(1);
    const [usersperpage, setuserperpages] = useState(10);

    const indexoflastuser = currentPage * usersperpage;
    const indexoffirstuser = indexoflastuser - usersperpage
    const filteruser = users.slice(indexoffirstuser, indexoflastuser)
    const totalpages = Math.ceil(users.length / usersperpage)
    const [Open, setOpen] = useState(false)


    const initialState = {
        SMTPHost: "",
        SMTPPort: "",
        Username: "",
        Password: '',

        ApiKeY: '',
        SenderEmail: '',
        SenderName: ''
    };

    const [formData, setFormData] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });
    };
    const SmtpSubmit = () => {
        const { SMTPHost, SMTPPort, Username, Password } = formData;

        if (
            !SMTPHost ||
            !SMTPPort ||
            !Username ||
            !Password
        ) {
            alert("All fields are required!");
            return;
        }

        console.log("Form Data:", formData);
        setOpen(false)
        setFormData(initialState);
    };
    const SendergridSubmit = () => {
        const { ApiKeY } = formData;
        if (
            !ApiKeY

        ) {
            alert("All fields are required!");
            return;
        }

        console.log("Form Data:", formData);
        setOpen(false)
        setFormData(initialState);
    };

    const [Emailtype, setEmailtype] = useState('SMTP')


    return (
        <>
            <div className=' dark:bg-[#121519] h-[100vh] px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Email Provider List</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                        <span>Email Provider List</span> </div>
                </div>
                <button
                    onClick={() => setOpen(true)}
                    className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
                    <RiAddLargeFill className='font-bold text-[16px]' />
                    Add Email
                </button>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
                        <div className='w-[100%] flex flex-wrap gap-4'>

                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Provider Type:</label>
                                <select name="" id=""
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    value={ProviderType}
                                    onChange={(e) => setProviderType(e.target.value)}
                                >
                                    <option value="">Select Provider Type</option>
                                    <option value="SMTP">SMTP</option>
                                    <option value="SendGrid">SendGrid</option>
                                </select>
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Usernmae:</label>
                                <input
                                    value={SMTPUsernmae}
                                    onChange={(e) => setSMTPUsernmae(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter User Name'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SendGrid Sender Email:</label>
                                <input
                                    value={SenderEmail}
                                    onChange={(e) => setSenderEmail(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter User Name'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button

                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>

                                <button
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>

                        </div>
                    </div>
                }
                <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] relative ">
                    <thead className="">
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>ID</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Provider Type</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>SMTP Host</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>SMTP Port </span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>

                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>SMTP Username</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Enable SSL</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Sender Email</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Sender Name</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>

                        </tr>
                    </thead>

                    <tbody>
                        {filteruser.length > 0 ? (
                            filteruser.map((user) => (
                                <tr
                                    key={user.id}
                                    className=" text-gray-500 odd:bg-white even:bg-[#edf1f5] 
        dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                >
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.WABANumber}</td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="9" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>

                        )}
                    </tbody>
                </table>
                <div className='flex justify-between w-[100%] '>
                    <p className='text-[11px] text-[#3f7fc8] mt-2' >Showing {indexoffirstuser} to {indexoflastuser} of {users.length} records</p>
                    <div className="flex justify-center mt-4 space-x-3 relative z-0">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setcurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition "
                        >
                            Prev
                        </button>

                        {/* {Array.from({length: Math.ceil(users.length /usersperpage )}).map((_, index)=>
                  
                  <button key={index}
                  onClick={()=> setcurrentPage(index + 1)}
                  className={`${currentPage === index + 1 ? 'bg-[#448c74] text-[#fff]':'bg-gray-200 '} px-2`}
                  >
                   {index + 1}
                  </button>
               )

               } */}


                        {<p className='text-[11px] text-[#3f7fc8] mt-2' > {currentPage} page of  {totalpages}  pages</p>

                        }

                        <button
                            disabled={currentPage === Math.ceil(users.length / usersperpage)}
                            onClick={() => setcurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>


            <Modal isOpen={Open} onClose={() => setOpen(false)} heading={'Create Email Provider'}>
                <div className='flex  items-center gap-2'>
                    <button
                        onClick={() => setEmailtype('SMTP')}
                        className={` text-[12px] font-bold ${Emailtype === 'SMTP' ? ' border-[#37715d] text-[#000]' : 'border-[#0000] text-[#61748f] '} pb-2 border-b-[2px]`}>
                        SMTP
                    </button>
                    <button
                        onClick={() => setEmailtype('SendGrid')}
                        className={`text-[#000] text-[12px] font-bold ${Emailtype === 'SendGrid' ? ' border-[#37715d] text-[#000]' : 'border-[#0000] text-[#61748f]'} pb-2 border-b-[2px]`}>
                        SendGrid
                    </button>
                </div>

                {Emailtype === 'SMTP' &&
                    <div className=' py-1 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-2'>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Host *</label>
                                <select name="SMTPHost" id=""
                                    value={formData.SMTPHost}
                                    onChange={handleChange}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                    <option value="">Select Channel</option>
                                    <option value="919216058712">
                                        919216058712
                                    </option>
                                </select>
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Port *</label>
                                <select name="SMTPPort" id=""
                                    value={formData.SMTPPort}
                                    onChange={handleChange}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                    <option value="PNG">PNG</option>
                                    <option value="SVG">
                                        SVG
                                    </option>
                                </select>
                            </div>

                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Username *</label>
                                <input
                                    name='Username'
                                    value={formData.Username}
                                    onChange={handleChange}
                                    placeholder='Enter Username'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Password *</label>
                                <input
                                    name='Password'
                                    value={formData.Password}
                                    onChange={handleChange}
                                    placeholder='Enter Password'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='mt-2 flex gap-2 items-center'>
                                <span className='text-[#121519] text-[13px] font-semibold'> Enable SSL/TLS
                                </span>
                                <button
                                    onClick={() =>
                                        setEnableSSLandTLS(!EnableSSLandTLS)
                                    }
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${EnableSSLandTLS
                                        ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                                >
                                    <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${EnableSSLandTLS ? "translate-x-[13px]" : ""}`}></div>
                                </button>
                            </div>



                        </div>
                    </div>
                }
                {Emailtype === 'SendGrid' &&
                    <div className=' py-1 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-2'>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>API Key *</label>
                                <input
                                    name='ApiKeY'
                                    value={formData.ApiKeY}
                                    onChange={handleChange}
                                    placeholder='Enter ApiKeY'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Sender Email *</label>
                                <input
                                    name='SenderEmail'
                                    value={formData.SenderEmail}
                                    onChange={handleChange}
                                    placeholder='Enter SenderEmail'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>

                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Sender Name</label>
                                <input
                                    name='SenderName'
                                    value={formData.SenderName}
                                    onChange={handleChange}
                                    placeholder='Enter SenderName'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>




                        </div>
                    </div>
                }
                <div className='w-full  flex items-center justify-end gap-1 mt-4'>
                    <button
                        onClick={Emailtype === 'SMTP' ? SmtpSubmit : SendergridSubmit}
                        className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2  gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
                    >
                        <span className='text-[12px] font-bold'>Save</span>
                    </button>

                    <button
                        onClick={() => {
                            setOpen(!Open)
                        }}
                        className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                    >
                        <span className='text-[12px] font-bold'>Close</span>
                    </button>
                </div>

            </Modal >
        </>
    )
}

export default EmailProvider
